export function linkUsed() {
    // return `http://localhost:3000`
    return `https://api.thelightcity.com.my`
}